export enum Dialogs {
  None = '',
  EventClosed = 'EventClosed',
  EventShop = 'EventShop',
  EditCeShippingAddress = 'EditCeShippingAddress',
  EditCePaymentMethod = 'EditCePaymentMethod',
  EditCeSubscription = 'EditCeSubscription',
  ConfirmMarisPickSubscription = 'ConfirmMarisPickSubscription',
  EditGrapefulSubscriptionAddressPayment = 'EditGrapefulSubscriptionAddressPayment',
  CancelMarisPicks = 'CancelMarisPicks',
  GrapefulRemove = 'GrapefulRemove',
}
